import { ObservableContextBase } from '../../../../../core/observable/context/base/implementation';
import { OBSERVABLE_CONTEXT_BASE_PRIVATE } from '../../../../../core/observable/context/base/privates';
import { AllowObservableContextBaseConstruct } from '../../../../../core/observable/context/base/constructor';
import { DistinctValueObservableEmit } from '../functions';
export function NewDistinctValueObservableContext(observable) {
    AllowObservableContextBaseConstruct(true);
    const context = new DistinctValueObservableContext(observable);
    AllowObservableContextBaseConstruct(false);
    return context;
}
export function DistinctValueObservableGetObservable(instance) {
    return instance[OBSERVABLE_CONTEXT_BASE_PRIVATE].observable;
}
export function DistinctValueObservableContextEmit(instance, value) {
    DistinctValueObservableEmit(instance.observable, value);
}
export class DistinctValueObservableContext extends ObservableContextBase {
    constructor(observable) {
        super(observable);
    }
    get observable() {
        return DistinctValueObservableGetObservable(this);
    }
    emit(value) {
        DistinctValueObservableContextEmit(this, value);
    }
}
//# sourceMappingURL=implementation.js.map